import { AxiosRequestConfig } from 'axios'
import {
  EventPublication as Data,
  EventPublicationCollection as Collection,
} from '@/typings/api/LkEventPublications'
import { BaseApiParams } from '@/typings/common'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'


export class LkEventPublicationsApi extends BaseLkApiAuth<Data, Collection> {
  protected readonly endpoint = 'event-publications';

  protected readonly hasFinishSlash = false;

  public getPublications<P extends BaseApiParams>(rawParams?: P, config?: AxiosRequestConfig) {
    const path = 'publications'
    const [url, params] = this.getUrl(path, rawParams)
    return this.request<Collection>('GET', url, { params, ...config })
  }
}
